/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosSearchRequest = {
    filterBy?: AptosSearchRequest.filterBy;
    term: string;
};

export namespace AptosSearchRequest {

    export enum filterBy {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
        COLLECTION = 'COLLECTION',
        COIN = 'COIN',
        MODULE = 'MODULE',
        OBJECT = 'OBJECT',
        FUNGIBLE_ASSET = 'FUNGIBLE_ASSET',
        ALL = 'ALL',
    }


}

